module.exports = __webpack_public_path__ + "4ee2808bc141c2a0c464bf75b570e6e8.jpg";